<template>
  <v-expansion-panels
    v-model="isOpen"
    multiple
    flat
  >
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-row align="center" justify="end"
               class="px-3 deep-purple--text lighten-3 font-weight-bold">
          {{ $t('common.filter') }}
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
          color="deep-purple lighten-5"
          elevation="2"
          class="pa-4"
          rounded="lg"
        >
          <v-form>
            <v-row align="center" justify="start" class="ma-0">
              <v-col cols="12" md="4" class="pa-2">
                <v-text-field
                  v-model="value.search"
                  :label="$t('campus_group_admins.search_by_name')"
                  @input="manageInput('search')"
                  hide-details
                  outlined
                  dense
                  background-color="white"
                  color="deep-purple"
                  prepend-inner-icon="mdi-magnify"
                />
              </v-col>
              <v-col cols="12" md="3" class="pa-2">
                <v-select
                  v-model="value.active"
                  :items="statusOptions"
                  :label="$t('common.status')"
                  @input="manageInput('active')"
                  hide-details
                  outlined
                  dense
                  background-color="white"
                  color="deep-purple"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="3" class="pa-2">
                <v-btn
                  @click="search"
                  color="deep-purple"
                  class="white--text"
                  block
                  elevation="2"
                  rounded
                >
                  <v-icon left>mdi-magnify</v-icon>
                  {{ $t('common.search') }}
                </v-btn>
              </v-col>
              <v-col cols="12" md="2" class="pa-2">
                <v-btn
                  @click="clearFilter"
                  color="grey lighten-1"
                  class="white--text"
                  block
                  elevation="1"
                  rounded
                  outlined
                >
                  <v-icon left>mdi-filter-remove</v-icon>
                  {{ $t('common.clear_filter') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { defaultCampusGroupAdminFilter } from '../../../constants/filters';

export default {
  name: 'CampusGroupAdminsFilter',
  props: {
    value: { type: Object, default: () => ({}) },
  },
  data: () => ({
    isOpen: [0],
    statusOptions: [
      { text: 'Activo', value: true },
      { text: 'Inactivo', value: false },
    ],
  }),
  methods: {
    manageInput(property) {
      this.$emit('input', { ...this.value, [property]: this.value[property] });
    },
    search() {
      this.$emit('search');
    },
    clearFilter() {
      this.$emit('input', { ...defaultCampusGroupAdminFilter });
      this.$emit('search');
    },
  },
};
</script>
